import React, { useState } from 'react';
import DeleteIcon from '@jbhi-fi/lanyard-ui/components/Icons/Delete';
import Button from '@jbhi-fi/lanyard-ui/components/Button';
import { styles } from './AttachedService.css';
import { ServiceIcon } from '../../ServiceIcon/ServiceIcon';
import { JBAlert } from '@jbhi-fi/lanyard-ui';
import { formatMoney } from '@jbhi-fi/lanyard-ui/global/utils';
import Spinner from '@jbhi-fi/lanyard-ui/components/Spinner';

export type AttachedServiceProps = {
  name: string;
  subtext?: string;
  onRemove?: () => Promise<void> | void;
  isValid?: boolean;
  imageUrl?: string;
  price?: number;
  isMobileExtra?: boolean;
  hideActions?: boolean;
  variant?: 'cart' | 'miniCart';
};

const MISSING_IMAGE_URL = 'https://cdn.shopify.com/s/images/admin/no-image-compact.gif';

export const AttachedService = ({
  name,
  subtext,
  onRemove,
  isValid = true,
  imageUrl = MISSING_IMAGE_URL,
  price,
  isMobileExtra = false,
  hideActions,
  variant,
}: AttachedServiceProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const testIdPrefix = `${variant ? `${variant}-` : ''}attached-service`;

  const handleRemove = async () => {
    if (!onRemove || isLoading) return;
    setIsLoading(true);
    try {
      await onRemove();
    } catch (error) {
      console.error(error);
    }
    setIsLoading(false);
  };

  return (
    <>
      {!isValid && (
        <JBAlert
          type="error"
          showIcon={true}
          noMargin={true}
          heading="Service no longer available"
          content="Please remove it to continue."
        />
      )}
      <div className={styles.wrapper({ isValid })} data-testid={`${testIdPrefix}-container`}>
        <div className={styles.detailsContainer}>
          <div className={styles.image}>
            <ServiceIcon imageUrl={imageUrl} size={34} isMobileExtra={isMobileExtra} />{' '}
          </div>
          <div>
            <div className={styles.text} data-testid={`${testIdPrefix}-label`}>
              {name}
            </div>
            <div className={styles.subtext} data-testid={`${testIdPrefix}-subtext`}>
              {subtext}
            </div>
          </div>
        </div>
        {!hideActions ? (
          <div className={styles.rightSide}>
            {isValid && price ? (
              <div className={styles.price} data-testid={`${testIdPrefix}-price`}>
                {formatMoney(price)}
              </div>
            ) : null}
            <div className={styles.actions}>
              {onRemove ? (
                isLoading ? (
                  <div className={styles.loading}>
                    <Spinner width={22} height={22} />
                  </div>
                ) : (
                  <Button
                    type="linkWithIcon"
                    iconPosition="left"
                    icon={<DeleteIcon />}
                    label="Remove"
                    onClick={handleRemove}
                    data-testid={`${testIdPrefix}-remove`}
                  />
                )
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
};
